import { FEATURE_FLAGS_ACTIONS, initialFeatureFlagsState } from './featureFlags.types';
export function featureFlagsReducer(state = initialFeatureFlagsState, action) {
    switch (action.type) {
        case FEATURE_FLAGS_ACTIONS.SET_FLAGS:
            return { ...state, data: action.payload };
        case FEATURE_FLAGS_ACTIONS.SET_FLAG:
            return { ...state, current: action.payload };
        case FEATURE_FLAGS_ACTIONS.SET_STATUS:
            return { ...state, status: action.payload };
        case FEATURE_FLAGS_ACTIONS.SET_CURRENT_STATUS:
            return { ...state, currentStatus: action.payload };
        case FEATURE_FLAGS_ACTIONS.SET_ERRORS:
            return { ...state, errors: [action.payload, ...state.errors] };
        case FEATURE_FLAGS_ACTIONS.CLEAR_ERRORS:
            return { ...state, errors: [] };
        case FEATURE_FLAGS_ACTIONS.CLEAR_FLAGS:
            return { ...state, data: {} };
        case FEATURE_FLAGS_ACTIONS.CLEAR_CURRENT:
            return { ...state, current: null, currentStatus: 'idle' };
        default:
            return state;
    }
}
